import React from 'react'

import requireLanguage from '../../hoc/requireLanguage'
import { AuthSplitLayout } from '../../layouts/auth-split'
// import FooterWrapper from 'wrappers/FooterWrapper'
// import HeaderWrapper from 'wrappers/HeaderWrapper'
// import { buildMultiLanguageLink } from '../shared/buildMultiLanguageLink'

const UnauthorizedLayout = ({
  children
  // selectedLanguage,
  // openLanguagePopup,
  // renderLanguagePopup
}) => {
  return (
    <AuthSplitLayout>
      {/* <HeaderWrapper /> */}
      <>{children}</>
      {/* <div id='main-footer'>
        <Footer
          multiLanguage={buildMultiLanguageLink(
            selectedLanguage,
            openLanguagePopup,
            renderLanguagePopup,
            true
          )}
        />
      </div> */}
    </AuthSplitLayout>
  )
}

export default requireLanguage(UnauthorizedLayout)
